
import { Vue, prop } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { formatByCountry, IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Utils";
import { ShipmentBookingDetail } from "@/domain/entities/ShipmentBooking";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";

class Props {
  commodity = prop<string>({
    default: "",
    type: String
  });
  email = prop<string>({
    default: "",
    type: String
  });
  identityNumber = prop<string>({
    default: "",
    type: String
  });
  interTaXNumber = prop<string>({
    default: "",
    type: String
  });
  dutyTaxTerms = prop<string>({
    default: "",
    type: String
  });
  photos = prop<string[]>({
    default: [],
    type: Array
  });
  sttCipl = prop<string[]>({
    default: [],
    type: Array
  });
  productTypeName = prop<string>({
    default: "",
    type: String
  });
  bookedByCountry = prop<string>({
    default: "",
    type: String
  });
  isShowInfoDetail = prop<boolean>({
    type: Boolean,
    default: false
  });
  isShipmentCaOldForm = prop<boolean>({
    type: Boolean,
    default: false
  });
  sttBookedByCountryMy = prop<boolean>({
    type: Boolean,
    default: false
  });
  isInternational = prop<boolean>({
    type: Boolean,
    default: false
  });
  detailData = prop<ShipmentBookingDetail>({
    type: Object,
    default: () => new ShipmentBookingDetail()
  })
}
class AdditionalInformationSection extends Vue.with(Props) {
  get accountCurrency(): "IDR" | "MYR" {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }

  formatPrice(val: number) {
    const prefix = IS_SENDER_ACCOUNT
      ? "Rp"
      : this.isAccountForeign || this.accountCurrency === "MYR"
      ? "RM"
      : "Rp";
    return formatByCountry(val, {
      type: "money",
      country: this.bookedByCountry || undefined,
      prefix
    });
  }
  
  formatQuantity(val: number) {
    return formatByCountry(val, {
      type: "quantity",
      country: this.bookedByCountry || undefined
    });
  }

  photoPreview = false;
  photo = "";
  onPreview(photo: string) {
    this.photo = photo;
    this.photoPreview = true;
  }

  getFileType(url: string): string {
    const urlParts = url.split(".");
    return urlParts[urlParts.length - 1].toLowerCase();
  }

  isPdfDocument(url: string): boolean {
    return this.getFileType(url) === "pdf";
  }

  getPdfDisplayName(url: string): string {
    const fileName = url.split("/").pop() || "document.pdf";
    return fileName.replace(/\.pdf$/i, "");
  }

  downloadPdf(url: string) {
    return downloadFile(url, this.getPdfDisplayName(url), ".pdf");
  }

  get photoPreviews() {
    return this.photos.map((item: any) => {
      return {
        image: item,
        url: item
      }
    });
  }

  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign || this.sttBookedByCountryMy;
  }
}

export default AdditionalInformationSection;
